import React, { useState, useCallback } from "react";

import Pluralize from "pluralize";

import referenceSourceValuesApi from "apis/reference_source_values";
import {
  Typography,
  Button,
  SearchBar,
  Table,
  Pagination,
} from "clearsense-ui/components";
import { LinkOut } from "clearsense-ui/icons";
import ContentBox from "components/Common/ContentBox";
import {
  DSDE_REFERENCE_LIST_COLUMN_DATA,
  MINIMUM_PAGE_SIZE,
  REFERENCE_SOURCE_EXPLORE_PAGE_URL,
} from "DataSources/constants/DSDE";
import useSearchAndPaginate from "hooks/useSearchAndPaginate";

const ReferenceValuesContainer = ({ associatedReferenceSource }) => {
  const [referenceSourceValues, setReferenceSourceValues] = useState({
    list: [],
    count: 0,
  });
  const [isLoading, setLoading] = useState(false);

  const fetchAssociatedReferenceSourceValues = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams(window.location.search);
      const search = params.get("search") || "";
      const currentPage = params.get("page") || 1;
      const pageSize = params.get("per_page") || 10;
      const { data } = await referenceSourceValuesApi.index(
        associatedReferenceSource.id,
        search.toLowerCase().trim(),
        currentPage,
        pageSize
      );
      setReferenceSourceValues({
        list: data.reference_source_values,
        count: data.reference_source_value_count,
      });
      setLoading(false);
    } catch (error) {
      logger.log(error);
    }
  }, []);

  const {
    search,
    currentPage,
    pageSize,
    setCurrentPage,
    setPageSize,
    setSearch,
  } = useSearchAndPaginate(fetchAssociatedReferenceSourceValues);

  return (
    <ContentBox className="w-2/3 space-y-5">
      <div className="flex items-center justify-between">
        <Typography style="h4" type="semibold">
          Reference Source Values
        </Typography>
        <Button
          label="View Reference Source"
          style="secondary"
          icon={LinkOut}
          to={REFERENCE_SOURCE_EXPLORE_PAGE_URL(associatedReferenceSource.id)}
        />
      </div>
      <div className="mt-4 flex items-center justify-between gap-4">
        <Typography style="h6" type="semibold">
          {Pluralize("Reference Value", referenceSourceValues.count, true)}
        </Typography>
        <SearchBar
          placeholder="Search by name or type or value"
          style="secondary"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <div className="cs-ui-table-background">
        <Table
          isLoading={isLoading}
          rowData={referenceSourceValues.list}
          columnData={DSDE_REFERENCE_LIST_COLUMN_DATA}
          rowKey={record => record.id}
        />
        {referenceSourceValues.count > MINIMUM_PAGE_SIZE && (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            showResultsPerPage
            totalRecordsCount={referenceSourceValues.count}
          />
        )}
      </div>
    </ContentBox>
  );
};

export default ReferenceValuesContainer;
